import Api from "./axios";

const api = new Api();

export const login = async (username, password) => {
    try {
        let data = await api.post("/login", { username, password });

        return data;
    } catch (error) {
        console.error("error ketika melakukan login", error);
        return false;
    }
};
